import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StoreUser, StoreUserBaseDto } from '@shared/StoreUser';
import { Observable } from 'rxjs';
import { AppConsts } from '@shared/app-consts';
import { AddressModel } from '@shared/AddressModel';
import { environment } from '@environment';
import { UpdatePhoneNumberRequest } from './security/update-phonenumber-request';
import { CollaboratorAddRequest } from '@shared/CollaboratorAddRequest';

@Injectable()
export class AccountService extends BaseService {
  
  constructor(private http: HttpClient) {
    super();
  }

  saveResponsable(request: CollaboratorAddRequest) :Promise<boolean> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "X-Requested-With": "XMLHttpRequest"
      })
    };
    const formData = new FormData();
    formData.append("user", JSON.stringify(request.User));
    if (request.File)
      formData.append('file', request.File, request.FileName);
      if(request.User.Id) 
      return this.http.post<boolean>(AppConsts.API_SERVICE_URL +"account/EditResponsableClient",formData,httpOptions).toPromise();
      else
      return this.http.post<boolean>(AppConsts.API_SERVICE_URL + "account/AddResponsableClient",formData,httpOptions).toPromise();
    
  }
  downloadCNI(cniName: string) {
    let httpOptions = this.getHttpHeader(true);
    return this.http.post(AppConsts.API_SERVICE_URL + 'collaborator/DownloadCNI', JSON.stringify(cniName), httpOptions)
      .toPromise()
      .then((response: any) => {
        return this.getFileFromResponse(response);
      });
  }
 

  getResponsable(responsableId: string): Observable<StoreUser> {
    let httpOptions = this.getHttpHeader(); 
   return this.http.post<StoreUser>(AppConsts.API_SERVICE_URL + "account/getUserDtoById?userId="+responsableId, httpOptions) as Observable<StoreUser>;
  }

  GetAllByRoleName(roleName: string): Observable<StoreUserBaseDto[]> {

    let httpOptions = this.getHttpHeader();

    httpOptions.params = {
      roleName: roleName
    };

    return this.http.get(AppConsts.API_SERVICE_URL + "account/collaborators/allByRoleName", httpOptions) as Observable<StoreUserBaseDto[]>;
  }


  getMyAddress():Observable<AddressModel>{ 
   let httpOptions = this.getHttpHeader();  
   return this.http.get(AppConsts.API_SERVICE_URL + "salarie/GetConnectedUserAddress", httpOptions) as Observable<AddressModel>;
  }

  getPhoneNumber():Observable<any>{
    let httpOptions = this.getHttpHeader();  
   return this.http.get(AppConsts.API_SERVICE_URL + "account/GetConnectedUserPhoneNumber", httpOptions) as Observable<any>;
  }

  sendChangePhoneNumberTokenAsync(phoneNumber : string):Observable<any>{
    let httpOptions = this.getHttpHeader();  
    return this.http.post<string>(AppConsts.API_SERVICE_URL + "account/SendChangePhoneNumberTokenAsync", JSON.stringify(phoneNumber), httpOptions) as Observable<any>;
  }

  updatePhoneNumberAsync(request : UpdatePhoneNumberRequest):Observable<any>{
    let httpOptions = this.getHttpHeader();  
    return this.http.post<UpdatePhoneNumberRequest>(AppConsts.API_SERVICE_URL + "account/UpdatePhoneNumberAsync", request, httpOptions) as Observable<any>;
  }

  getTwoFactorEnabled():Observable<any>{
    let httpOptions = this.getHttpHeader();  
   return this.http.get(AppConsts.API_SERVICE_URL + "account/GetTwoFactorEnabledAsync", httpOptions) as Observable<any>;
  }

  setTwoFactorEnabledAsync(isEnabled : boolean):Observable<any>{
    let httpOptions = this.getHttpHeader();  
    return this.http.post<UpdatePhoneNumberRequest>(AppConsts.API_SERVICE_URL + "account/SetTwoFactorEnabledAsync", JSON.stringify(isEnabled), httpOptions) as Observable<any>;
  }
 
}
